<form [formGroup]="userFormService.userForm">
  <section class="mb-4 rounded-lg border border-gray-200 bg-white p-4">
    <h2 class="mb-4 text-lg text-primary-500">
      {{ "accountMenu.userInformation" | transloco }}
    </h2>

    <!-- First Name -->
    <div class="mb-4 flex flex-row flex-wrap gap-4">
      <div class="flex-1">
        <label for="firstName" class="text-sm font-semibold text-greyscale-600">{{
          "accountMenu.firstName" | transloco
        }}</label>
        <input
          id="firstName"
          type="text"
          pInputText
          formControlName="firstName"
          [fluid]="true"
        />
      </div>

      <!-- Last Name -->
      <div class="flex-1">
        <label for="lastName" class="text-sm font-semibold text-greyscale-600">{{
          "accountMenu.lastName" | transloco
        }}</label>
        <input
          id="lastName"
          type="text"
          pInputText
          formControlName="lastName"
          [fluid]="true"
        />
      </div>
    </div>
    <!-- Email -->
    <div class="mb-4 flex flex-row flex-wrap gap-4">
      <div class="flex-1">
        <label for="emails" class="text-sm font-semibold text-greyscale-600">{{
          "accountMenu.email" | transloco
        }}</label>
        <input
          id="emails"
          type="email"
          pInputText
          formControlName="email"
          [fluid]="true"
        />
      </div>

      <!-- Phone -->
      <div class="flex-1">
        <label for="phone" class="text-sm font-semibold text-greyscale-600">{{
          "accountMenu.phone" | transloco
        }}</label>
        <input
          id="phone"
          type="text"
          pInputText
          formControlName="phone"
          [fluid]="true"
        />
      </div>
    </div>

    <!-- Update User Info Button -->
    <div class="flex justify-start">
      <p-button
        type="button"
        (click)="userFormService.submitUserInfo()"
        [disabled]="!userFormService.userInfoDirty()"
        [loading]="userFormService.isLoadingUserInfo()"
      >
        <lucide-angular [img]="userCheckIcon" class="mr-2 h-4 w-4" />
        <span class="font-semibold">{{ "accountMenu.updateUserInfo" | transloco }}</span>
      </p-button>
    </div>
  </section>

  <section class="mb-4 rounded-lg border border-gray-200 bg-white p-4">
    <h2 class="mb-4 text-lg text-primary-500">
      {{ "accountMenu.language" | transloco }}
    </h2>
    <div class="mb-4 max-w-80 flex-1">
      <label for="preferredLanguage" class="text-sm font-semibold text-greyscale-600">{{
        "accountMenu.selectLang" | transloco
      }}</label>
      <p-select
        id="preferredLanguage"
        formControlName="preferredLanguage"
        [options]="[
          { label: 'Français', value: 'fr' },
          { label: 'English', value: 'en' },
          { label: 'Nederlands', value: 'nl' },
        ]"
        optionLabel="label"
        optionValue="value"
        [fluid]="true"
      />
    </div>

    <!-- Update Language Button -->
    <div class="flex justify-start">
      <p-button
        type="button"
        (click)="userFormService.submitLanguage()"
        [disabled]="!userFormService.languageDirty()"
        [loading]="userFormService.isLoadingLanguage()"
      >
        <lucide-angular [img]="globeIcon" class="mr-2 h-4 w-4" />
        <span class="font-semibold">{{ "accountMenu.updateLanguage" | transloco }}</span>
      </p-button>
    </div>
  </section>

  <!-- Communications Section -->
  <section class="mb-4 rounded-lg border border-gray-200 bg-white p-4">
    <h2 class="mb-4 text-lg text-primary-500">
      {{ "accountMenu.communications.title" | transloco }}
    </h2>

    <div class="mb-4">
      <div class="flex items-center gap-3">
        <p-toggleSwitch formControlName="marketingOptOut" inputId="marketingOptOut" />
        <label for="marketingOptOut" class="text-sm text-greyscale-700">
          {{ "accountMenu.communications.optOutLabel" | transloco }}
        </label>
      </div>
      <p class="mt-2 text-xs text-greyscale-500">
        {{ "accountMenu.communications.transactionalNote" | transloco }}
      </p>
    </div>

    <!-- Update Communications Button -->
    <div class="flex justify-start">
      <p-button
        type="button"
        (click)="userFormService.submitCommunications()"
        [disabled]="!userFormService.communicationsDirty()"
        [loading]="userFormService.isLoadingCommunications()"
      >
        <lucide-angular [img]="mailIcon" class="mr-2 h-4 w-4" />
        {{ "accountMenu.communications.save" | transloco }}
      </p-button>
    </div>
  </section>
</form>
<app-change-password />
<p-toast></p-toast>
